export default __webpack_public_path__ + "static/media/roqqu-logo.5975eb03.svg";